var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2929_916",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2929_916",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC10lEQVR4nO2dy04UQRSGjySuIL4EU0XCAlET0TcQ4yVRl6y7KpP4DGy8rBF9AcIzibrAxOADeFnohjbVwwJ6YDR29czP1PcltT1dc77UqZqcxTEDAAAAAAC4DNyqrtpKeGYu7puLB+biT/OxLnq58OMkF/s2iE+bHE0FHx6bi59mngAvvlKOVuKjHk1sL5gLr2f+Q/2lWsfm46smd9lBRv3/YsLL/GVqZPv0R36ZDzvmqg1b21q00lnbWmxy4eOuufh77KQMqod5PpQup/E748hcuJ7nA3OIG643OTpzp4SPeS769Jpqnwxk/J1BvDF2UtLrqzPpGXdWyE73oIXgwtvWKdnLEfRDK+jtHHstgkG803oKH3QPmv7wnA66OlzKsdciWB0utYR87x60/YSDGecPId1AiBgIEQMhYiBEDISIgRAxECIGQsRAiBgIEUNOiAv3zcXPAv3tutMa/YbNqecve0Afvsw8mT7bOpp6/rIHREgtJiRumouHc1CyDs1X96aev/4DFoZHiBYIEQMhYiBEDISIgRAxECIGQsRAiBgIEQMhYiBEDISIISeEjmGtJYQGVY0QTwt30gmjY+iVSlbpeLWSVToeIVogRAyEiIEQMRAiBkLEQIgYCBEDIWIgRAyEiIEQMeSE0DGstYTQMawR4ukYTjphdAy9UskqHa9WskrHI0QLhIiBEDEQIgZCxECIGAgRAyFiIEQMhMy7kDSE5HRABrr8O4Pn184KCd8s/8ijaqN70EJYru72MPKoPRQsvsmx1yJw8V3+oWDnjs0brufY71yzXN0cG5vnqic9DpZEymQZ4Ws/gyUTaepxe/TqyP5uUye56K3JQcpFKlPnjl6NDywraepxf73qeV8vLD/bCydSWkOKWXZxDo5PZFyx3kjlK9VDRNQTc5BylL1MXUS6nNKg3fSM8+H92DTQEpdLOWhysde8prJd4AAAAAAAANYrfwBfA0ScHgnQLwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.931fb43d8c8399f2e29174538117fc25.svg";
export { ForwardRef as ReactComponent };